@if (cosmetic$ | async; as cosmetic) {
  <div class="grid gap-10 lg:grid-cols-2">
    <app-public-cosmetic-images-galleria [files]="cosmetic.files" />

    <div>
      <div class="font-['Poppins'] text-4xl font-bold uppercase">
        {{ cosmetic.name }}
      </div>

      <div class="mt-10">
        @for (attribute of cosmetic.attributes; track attribute.id) {
          <div class="flex gap-1">
            <span class="font-bold">{{ attribute.label }}:</span>
            <app-summernote-html-preview [html]="attribute.content" />
          </div>
        }
      </div>

      <div class="mt-5">
        <app-router-link
          class="inline-flex"
          [route]="Route.PL_BrandDetails"
          [params]="cosmeticDetailsParams(cosmetic.cosmeticBrand.slug)">
          <app-image-thumbnail
            [rounded]="false"
            size="lg">
            <img
              [fill]="true"
              [ngSrc]="cosmetic.cosmeticBrand.logo.url"
              [alt]="cosmetic.cosmeticBrand.logo.url"
              class="object-contain"
              loading="lazy" />
          </app-image-thumbnail>
        </app-router-link>
      </div>

      <div class="mt-10">
        <p-accordion
          [multiple]="true"
          [value]="[0]">
          @for (
            characteristic of cosmetic.characteristics;
            track characteristic.id;
            let index = $index
          ) {
            <p-accordion-panel [value]="index">
              <p-accordion-header>
                {{ characteristic.label }}
              </p-accordion-header>

              <p-accordion-content>
                <p class="m-0">
                  <app-summernote-html-preview
                    [html]="characteristic.content" />
                </p>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>

      <div class="mt-10">
        <div class="mb-1 font-bold">
          <app-icon
            class="text-sky-600"
            [icon]="Icon.ExclamationCircleFill" />

          Ważne informacje o produkcie
        </div>

        <div class="px-5 font-light">
          Informacje o produkcie są zgodne ze specyfikacją producenta aktualną
          na dzień ich publikacji. Aby mieć pewność, że dysponujesz najnowszymi
          danymi, zachęcamy do weryfikacji opisu bezpośrednio na oficjalnej
          stronie producenta.
        </div>
      </div>

      <div class="mt-10">
        <div class="grid grid-cols-2 gap-4">
          @if (isNotNil(cosmetic.vendorUrl)) {
            <app-external-link
              [link]="cosmetic.vendorUrl"
              [contents]="true">
              <app-slim-button
                label="Kup produkt"
                theme="dark" />
            </app-external-link>
          }

          @if (isNotNil(cosmetic.box)) {
            <app-router-link
              [contents]="true"
              [route]="Route.PL_BoxDetails"
              [params]="prepareBoxDetailsParams(cosmetic.box)">
              <app-slim-button
                label="Zobacz edycję"
                theme="primary">
              </app-slim-button>
            </app-router-link>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
